export default "__VITE_ASSET__DRaeDSac__"